import React, { useState } from "react";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import TopBar from "./components/layout/TopBar";
import Sidebar from "./components/layout/Sidebar";
import Login from "./pages/Login";
import MIS from "./pages/MIS";
import MISChannelwise from "./pages/MISChannelwise";
import DataHub from "./pages/DataHub";
import ComingSoon from "./pages/ComingSoon";

export type SectionId =
  | "mis"
  | "mis-channelwise"
  | "expenses"
  | "forecast"
  | "esop-captable"
  | "round-investments"
  | "finance-reports"
  | "payroll"
  | "compliances"
  | "insurance"
  | "agreement"
  | "data-hub";

export interface NavSection {
  id:        SectionId;
  label:     string;
  group:     string;
  ready:     boolean;
  adminOnly?: boolean;
}

export const NAV_SECTIONS: NavSection[] = [
  { id:"mis",               label:"MIS",               group:"MIS",         ready:true  },
  { id:"mis-channelwise",   label:"MIS Channelwise",   group:"MIS",         ready:true  },
  { id:"expenses",          label:"Expenses Analysis", group:"MIS",         ready:false },
  { id:"forecast",          label:"Forecast & Budget", group:"MIS",         ready:false },
  { id:"esop-captable",     label:"ESOP & Cap Table",  group:"Corporate",   ready:false },
  { id:"round-investments", label:"Round Investments", group:"Corporate",   ready:false },
  { id:"finance-reports",   label:"Finance Reports",   group:"Finance",     ready:false },
  { id:"payroll",           label:"Payroll & Salaries",group:"Finance",     ready:false },
  { id:"compliances",       label:"Compliances",       group:"Compliance",  ready:false },
  { id:"insurance",         label:"Insurance Tracker", group:"Compliance",  ready:false },
  { id:"agreement",         label:"Agreement Tracker", group:"Compliance",  ready:false },
  { id:"data-hub",          label:"Data Hub",          group:"System",      ready:true  },
];

function renderPage(sectionId: SectionId) {
  switch (sectionId) {
    case "mis":             return <MIS />;
    case "mis-channelwise": return <MISChannelwise />;
    case "data-hub":        return <DataHub />;
    default:                return <ComingSoon />;
  }
}

// Inner app — only rendered when logged in
function Dashboard() {
  const [activeSection, setActiveSection] = useState<SectionId>("mis");
  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100vh", overflow:"hidden", backgroundColor:"var(--bg-primary)" }}>
      <TopBar />
      <div style={{ display:"flex", flex:1, overflow:"hidden" }}>
        <Sidebar activeSection={activeSection} onNavigate={(id) => setActiveSection(id)} />
        <main style={{ flex:1, overflowY:"auto", backgroundColor:"var(--bg-primary)", padding:"24px" }}>
          {renderPage(activeSection)}
        </main>
      </div>
    </div>
  );
}

// Auth gate — shows login or dashboard based on session
function AppInner() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight:"100vh", backgroundColor:"#060E17", display:"flex", alignItems:"center", justifyContent:"center" }}>
        <div style={{ color:"#C9A84C", fontSize:"13px" }}>Loading...</div>
      </div>
    );
  }

  if (!user) return <Login />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppInner />
      </ThemeProvider>
    </AuthProvider>
  );
}
